export default {
  TableHeadMaintenance: [
    [
      {
        displayName: 'maintenance.maintenance_table_head.number',
      },
      {
        displayName: 'maintenance.maintenance_table_head.partner',
      },
      {
        displayName: 'maintenance.maintenance_table_head.status',
      },
    ],
  ],
};
